import { flowRight, get } from 'lodash';
import * as I18n from 'i18n-js';
import * as React from 'react';
import { graphql, ChildProps } from 'react-apollo';
import gql from 'graphql-tag';

import { HomepageBumpedListings as HomepageBumpedListingsSchema } from '../../../schemas/rql';

import ListingsCollection, { ListingsCollection as ListingsCollectionClass } from '@reverbdotcom/commons/dist/components/listings_collection';
import { withUserContext, IUser } from '@reverbdotcom/commons/dist/components/user_context_provider';
import URLHelpers from '../../shared/url_helpers';
import CoreLink from '@reverbdotcom/commons/dist/components/core_link';

import { isExperimentEnabled, canViewFinancingOptions } from '@reverbdotcom/commons/dist/user_context_helpers';
import { experiments } from '../../shared/constants';

function showAffirmMonthlyEstimate(user) {
  return canViewFinancingOptions(user) && isExperimentEnabled(user, experiments.AFFIRM_HOMEPAGE_CALLOUTS);
}

interface ExternalProps {
  user?: IUser;
}

type Props = ChildProps<ExternalProps, HomepageBumpedListingsSchema.Query, HomepageBumpedListingsSchema.Variables>;

const withQuery = graphql<ExternalProps, HomepageBumpedListingsSchema.Query, HomepageBumpedListingsSchema.Variables>(
  gql`
    query HomepageBumpedListings(
      $loggedOut: Boolean!
      $showAffirmMonthlyEstimate: Boolean!
    ) {
      bumpedListings {
        ... ListingsCollection
        ... LoggedInFields @skip(if: $loggedOut)
        ...BumpKey
        ... FinancingFields @include(if: $showAffirmMonthlyEstimate)
      }
    }
    ${ListingsCollectionClass.fragments.listing}
    ${ListingsCollectionClass.fragments.loggedInFields}
    ${ListingsCollectionClass.fragments.bumpKey}
    ${ListingsCollectionClass.fragments.financingFields}
  `,
  {
    options: (ownProps) => {
      return {
        ssr: false,
        variables: {
          loggedOut: !!ownProps.user?.loggedOut,
          showAffirmMonthlyEstimate: showAffirmMonthlyEstimate(ownProps.user),
        },
      };
    },
  },
);

export const BumpedListingsFetcherBase = (componentName, keyStr) => (props: Props) => {
  const listings = get(props, keyStr) || [];

  return (
    <ListingsCollection
      title={I18n.t('discovery.bumpsView.promotedListings')}
      callToAction={(
        <CoreLink to={URLHelpers.cmsPagePath('bump')}>
          {I18n.t('discovery.bumpsView.learnAboutBump')}
        </CoreLink>
      )}
      listings={listings}
      componentName={componentName}
      loading={props.data.loading}
      showEstimatedMonthlyPayment={showAffirmMonthlyEstimate(props.user)}
    />
  );
};

const HomepageBumpedListingsFetcher = BumpedListingsFetcherBase(
  'HomepageBumpedListings',
  'data.bumpedListings',
);

export default flowRight([
  withUserContext,
  withQuery,
])(HomepageBumpedListingsFetcher);



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/homepage/homepage_bumped_listings.tsx